import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const AudioFileIcon = createSvgIcon(
  <g>
    <rect x="8" y="10" width="48" height="44" rx="8" fill="#C026D3" />
    <path
      d="M28 22v18M28 22l14-3.5v18"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="24" cy="40" r="4.4" fill="#FFFFFF" />
    <circle cx="38" cy="36.5" r="4.4" fill="#FFFFFF" />
  </g>,
  'AudioFileIcon',
);
